import { useMutation, useQuery } from '@apollo/client';
import { isNil } from 'ramda';
import { useEffect } from 'react';

import {
  INTAKE_REQUEST_RELEASE_MUTATION,
  INTAKE_REQUEST_RESUBMIT_MUTATION,
} from '../IntakeRequestSubmitStep.mutation.gql';
import { INTAKE_DEMAND } from '../IntakeRequestSubmitStep.query.gql';
import { SvbrgChatMessageStatus, SvbrgIntakeStatus } from '@/generated/gql/graphql';
import { useChatSession } from '~/modules';

export const useIntakeRequestSubmitState = (status?: SvbrgChatMessageStatus) => {
  const session = useChatSession();

  const { data, loading, refetch } = useQuery(INTAKE_DEMAND, {
    variables: session,
    fetchPolicy: 'cache-and-network',
  });

  const chatSession = data?.sevenbridges?.chatSession;
  const demandId = chatSession?.demandId;

  const [release, { loading: releaseLoading }] = useMutation(INTAKE_REQUEST_RELEASE_MUTATION, {
    variables: {
      data: {
        chatSessionId: session.id,
      },
    },
  });

  const [resubmit, { loading: resubmitLoading }] = useMutation(INTAKE_REQUEST_RESUBMIT_MUTATION, {
    variables: {
      data: {
        chatSessionId: session.id,
      },
    },
  });

  useEffect(() => {
    if (status === SvbrgChatMessageStatus.COMPLETED && isNil(demandId)) {
      refetch();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [status, demandId]);

  const disabled = loading || resubmitLoading || releaseLoading || status !== SvbrgChatMessageStatus.PROCEED;
  const resubmitDisabled = loading || resubmitLoading || chatSession?.status !== SvbrgIntakeStatus.BLOCKED;
  const openDemandDisabled =
    loading ||
    resubmitLoading ||
    releaseLoading ||
    chatSession?.status !== SvbrgIntakeStatus.IN_PROGRESS ||
    isNil(demandId);

  return {
    // Data
    chatSession,
    demandId,

    // Loading states
    loading,
    releaseLoading,
    resubmitLoading,
    disabled,
    resubmitDisabled,
    openDemandDisabled,
    // Actions
    release,
    resubmit,
    refetch,
  };
};
